import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteNotificationsBulkParams {
  notificationIds: string[];
}

export interface DeleteNotificationsBulkResponse {
  success: boolean;
  data: { deletedCount: number };
}

const deleteNotificationsBulk: MutationFunction<
  number,
  DeleteNotificationsBulkParams
> = async (args) => {
  if (isMockServices()) return (await mock(_mockType)).deletedCount;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteNotificationsBulkResponse>(
    '/users/me/notifications/bulk-delete',
    {
      method: 'POST',
      body: { notificationIds: args.notificationIds },
    },
  );
  if (response.data?.success && response.data?.data != null)
    return response.data.data.deletedCount;

  throw new Error('Failed to delete notifications');
};

export default deleteNotificationsBulk;

const _mockType = {
  deletedCount: 1,
};
